import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
const screenfull = require('screenfull');
const browser = require('jquery.browser');
declare var $: any;

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../../core/settings/settings.service';
import { MenuService } from '../../../core/menu/menu.service';
import { Router } from '@angular/router';
import { LoginModel } from '../../../login/login.model';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { StoreService } from '@ngx-resource-toolkit/core';
import { TabsService } from '../../../shared/services/tabs.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {

    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    private menuSub: Subscription;

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton') fsbutton;  // the fullscreen button

    constructor(
        private http: HttpClient,
        private router: Router,
        public menu: MenuService,
        public userblockService: UserblockService,
        public settings: SettingsService,
        private store: StoreService,
        private tabs: TabsService
        ) {

        // show only a few items on demo
        // this.menuItems = menu.getMenu().slice(0,4); // for horizontal layout

    }

    ngOnInit() {
        // this.menuItems = this.menu.getMenu().slice(0,4); // for horizontal layout
        this.menuSub = this.menu.getMenu().subscribe(menuItems => {
            console.log('this.menuItems', this.menuItems);
            this.menuItems = menuItems;
        });

        this.isNavSearchVisible = false;
        if (browser.msie) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
    }

    ngOnDestroy() {
        this.menuSub.unsubscribe();
    }

    logout() {

        let model = new LoginModel();
        model.getResource('default', 'get')
        .call(this.http, 'deconnecte', [], {headers: {'Authorization': this.settings.getUserSetting('token')}})
        .subscribe((data) => {
            console.log('logout success', data);

            if (data.success) {
                this.settings.removeUserSetting();
                this.removeTabs();
                this.router.navigate(['/login']);
            } else {
                // this.loginError = data.message;
                // console.log('logout data not success', data);
            }


        }, (err) => console.log('Logout error', err));

    }

    removeTabs() {
        // Vidage du store pour forcer à recharger les données
        this.store.createStore();
        // Il faut aussi supprimer les tabs ouverts (non ouverts par défaut)
        this.tabs.removeAllRemovableTabs();
    }

    getIsTest(): boolean {
        const estTest = environment.proxyUrl.indexOf('test') >= 0;
        return estTest;
    }
    getIsDemo(): boolean {
        return environment.proxyUrl.indexOf('demo') >= 0;
    }
    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    getAnneeTitre() {
        return this.settings.user.anneeScolaireLibelle ?
            this.settings.user.anneeScolaireLibelle :
            // this.settings.user.anneeScolaire + ' - ' + (parseInt(this.settings.user.anneeScolaire) + 1) :
            '';
    }
    getIsAnneeDefault() {
        return this.settings.user.anneeScolaire === localStorage.getItem('defaultYear');
    }

    toggleOffsidebar() {
        this.settings.layout.offsidebarOpen = !this.settings.layout.offsidebarOpen;
    }

    toggleCollapsedSideabar() {
        this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
    }

    isCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }

    toggleFullScreen(event) {

        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        let el = $(this.fsbutton.nativeElement);
        if (!screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        }
        else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/core/layout/header/header.component.ts